"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgTypes = exports.Errors = exports.Events = void 0;
const neo3_dapi_1 = __importDefault(require("neo3-dapi"));
// O3 Wallet Events Enum
var Events;
(function (Events) {
    Events[Events["Ready"] = neo3_dapi_1.default.Constants.EventName.READY] = "Ready";
    Events[Events["AccountChanged"] = neo3_dapi_1.default.Constants.EventName.ACCOUNT_CHANGED] = "AccountChanged";
    Events[Events["Connected"] = neo3_dapi_1.default.Constants.EventName.CONNECTED] = "Connected";
    Events[Events["Disconnected"] = neo3_dapi_1.default.Constants.EventName.DISCONNECTED] = "Disconnected";
    Events[Events["NetworkChanged"] = neo3_dapi_1.default.Constants.EventName.NETWORK_CHANGED] = "NetworkChanged";
    Events[Events["BlockChanged"] = neo3_dapi_1.default.Constants.EventName.BLOCK_HEIGHT_CHANGED] = "BlockChanged";
    Events[Events["TxConfirmed"] = neo3_dapi_1.default.Constants.EventName.TRANSACTION_CONFIRMED] = "TxConfirmed";
})(Events = exports.Events || (exports.Events = {}));
// O3 Wallet Error Map
var Errors;
(function (Errors) {
    Errors["Denied"] = "CONNECTION_DENIED";
    Errors["NoProvider"] = "NO_PROVIDER";
    Errors["Rpc"] = "RPC_ERROR";
    Errors["MalformedInput"] = "MALFORMED_INPUT";
    Errors["Cancelled"] = "CANCELED";
    Errors["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
    Errors["Unknown"] = "UNKNOWN_ERROR";
})(Errors = exports.Errors || (exports.Errors = {}));
// Invoke Function Types
var ArgTypes;
(function (ArgTypes) {
    ArgTypes["String"] = "String";
    ArgTypes["Boolean"] = "Boolean";
    ArgTypes["Hash160"] = "Hash160";
    ArgTypes["Hash256"] = "Hash256";
    ArgTypes["Integer"] = "Integer";
    ArgTypes["ByteArray"] = "ByteArray";
    ArgTypes["Array"] = "Array";
    ArgTypes["Address"] = "Address";
})(ArgTypes = exports.ArgTypes || (exports.ArgTypes = {}));
